import { render, staticRenderFns } from "./addcommercial_jsxx_edit.vue?vue&type=template&id=71c41c5f&scoped=true&"
import script from "./addcommercial_jsxx_edit.vue?vue&type=script&lang=js&"
export * from "./addcommercial_jsxx_edit.vue?vue&type=script&lang=js&"
import style0 from "./addcommercial_jsxx_edit.vue?vue&type=style&index=0&id=71c41c5f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c41c5f",
  null
  
)

export default component.exports